export default __webpack_public_path__ + "static/media/formation-outillage-equipe-velo.7d3275c2.jpg";